(function () {
  if (window.__bsGridPageInit) return;
  window.__bsGridPageInit = true;

  var navigationGeneration = 0;

  function invalidateGridRedirect() {
    navigationGeneration += 1;
    document.querySelectorAll('[data-bs-grid-redirect]').forEach(function (node) {
      node.remove();
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[data-grid-page]') : null;
    if (!link) return;
    event.preventDefault();
    event.stopPropagation();
    invalidateGridRedirect();

    var url = new URL(window.location.href);
    url.searchParams.set('grid_page', link.getAttribute('data-grid-page'));
    var shop = link.getAttribute('data-shop-page') || '1';
    if (shop === '1') url.searchParams.delete('page');
    else url.searchParams.set('page', shop);

    var host = link.closest('page-pagination') || link;
    host.dispatchEvent(new CustomEvent('pagination:page-changed', {
      bubbles: true,
      detail: { url: url.toString() }
    }));
  }, true);

  document.addEventListener('facet:criteria-changed', function (event) {
    if (!event.detail || !event.detail.url) return;
    invalidateGridRedirect();
    var url = new URL(event.detail.url, window.location.origin);
    if (!url.searchParams.has('grid_page') && !url.searchParams.has('page')) return;
    url.searchParams.delete('grid_page');
    url.searchParams.delete('page');
    event.stopPropagation();
    var facet = (event.target && event.target.closest && event.target.closest('product-facet')) || document.querySelector('product-facet');
    if (!facet) return;
    facet.dispatchEvent(new CustomEvent('facet:criteria-changed', {
      bubbles: true,
      detail: { url: url.toString() }
    }));
  }, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.name !== 'sort_by') return;
    invalidateGridRedirect();
    var url = new URL(window.location.href);
    if (!url.searchParams.has('grid_page')) return;
    url.searchParams.delete('grid_page');
    url.searchParams.delete('page');
    history.replaceState({}, '', url.toString());
  }, true);

  function recoverGridPage(generation) {
    if (generation !== navigationGeneration) return;
    if (window.__bsGridRedirecting) return;
    var marker = document.querySelector('[data-bs-grid-redirect]');
    if (!marker) return;

    var page = marker.getAttribute('data-bs-grid-page');
    var shop = marker.getAttribute('data-bs-shop-page') || '1';
    marker.remove();
    if (generation !== navigationGeneration) return;

    var url = new URL(window.location.href);
    url.searchParams.set('grid_page', page);
    if (shop === '1') url.searchParams.delete('page');
    else url.searchParams.set('page', shop);
    if (url.toString() === window.location.href) return;
    if (window.__bsGridLastRedirect === url.toString()) return;
    window.__bsGridLastRedirect = url.toString();

    var facet = document.querySelector('product-facet');
    if (!facet) {
      window.location.replace(url.toString());
      return;
    }
    facet.dispatchEvent(new CustomEvent('pagination:page-changed', {
      bubbles: true,
      detail: { url: url.toString() }
    }));
  }

  function markerWasAdded(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (!node || node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-bs-grid-redirect]')) return true;
        if (node.querySelector && node.querySelector('[data-bs-grid-redirect]')) return true;
      }
    }
    return false;
  }

  var observer = new MutationObserver(function (mutations) {
    if (!markerWasAdded(mutations)) return;
    var generation = navigationGeneration;
    window.setTimeout(function () {
      recoverGridPage(generation);
    }, 0);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  recoverGridPage(navigationGeneration);
})();
